let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Rog35")).then(() => parcelRequire('5ATSG'));